// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"ae3a11c1","101":"98c2a984","232":"f346081b","237":"f6a496e9","453":"2d6d3f60","546":"505514b1","599":"52930e91","705":"537c65c8","776":"7d29271c","959":"789fdf96"}[chunkId] + ".chunk.js";
};